<template>
  <div class="verificacao-token">
    <div class="loading-text">
      Aguarde, estamos verificando seu acesso
    </div>
    <v-progress-circular :size="70" :width="6" color="primary" indeterminate></v-progress-circular>
  </div>
</template>
<script>
import atendimentoHaiService from '@/services/atendimentoHai'
import authenticationService from '@/services/authentication'

export default {
  methods: {
    async verifyToken() {
      const token = this.$route.query.token
      try {
        const { data } = await atendimentoHaiService.validateToken(token)
        authenticationService.setToken(data.userToken)
        this.$router.push({ name: 'fila-atendimento-hai', params: { id: data.id } })
      } catch (error) {
        this.$showErrorMessage(error.response.data.message)
        this.$router.push({ name: 'erro-atendimento-hai' })
      }
    }
  },
  mounted() {
    this.verifyToken()
  }
}
</script>
<style scoped>
.verificacao-token {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 40px;
  align-items: center;
  justify-content: center;
}

.loading-text {
  font-weight: 700;
  font-size: 1.2rem;
}
</style>
